import { css } from 'styled-components';
import { device } from '../breakpoints';
import { getHeaderTextLayout } from './HeaderTextLayout.styles';

export const getHeroLayout = () => css`
    ${getHeaderTextLayout()}
    padding-top: 45%;

    @media ${device.GteSmall} {
        padding-top: 55%;
    }

    @media ${device.GteMedium} {
        padding-top: 37%;
    }

    @media ${device.GteLarge} {
        padding-top: 42%;
    }
`;
